// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.c24279430a20346a2fc65a75664512edd9ce13df.js";
};